import React, { useState, useEffect } from 'react';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import Typography from '@mui/material/Typography';
import { IconButton, useTheme } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import DialogContent from '@mui/material/DialogContent';
import RoleSelectionDailyUpdates from '../molecules/RoleSelectionDailyUpdates';

const DailyUpdatesAssistant = ({ open, onClose }: { open: boolean; onClose: () => void }) => {
	const [isMobile, setIsMobile] = useState(false);
	const theme = useTheme();
	const isDark = theme.palette.mode === 'dark';
	useEffect(() => {
		const checkScreenSize = () => {
			setIsMobile(window.innerWidth <= 768);
		};

		checkScreenSize();

		window.addEventListener('resize', checkScreenSize);

		return () => {
			window.removeEventListener('resize', checkScreenSize);
		};
	}, []);
	return (
		<Dialog
			open={open}
			onClose={onClose}
			fullWidth
			maxWidth="lg"
			PaperProps={{
				sx: {
					borderRadius: isMobile ? 0 : 3,
					height: 'auto',
					minHeight: isMobile ? '100vh' : 'auto',
					m: isMobile ? 0 : '32px auto auto',
					maxWidth: isMobile ? '100%' : '1200px',
					width: '100%',
					overflow: 'hidden',
					background: isDark
						? theme.palette.background.paper
						: 'linear-gradient(to bottom, #ffffff, #f7f9fc)',
					boxShadow: '0 8px 32px rgba(0, 0, 0, 0.12)',
					position: 'absolute',
					top: isMobile ? 0 : 32
				}
			}}
			fullScreen={isMobile}
		>
			<DialogTitle
				sx={{
					display: 'flex',
					justifyContent: 'center',
					alignItems: 'center',
					position: 'relative',
					p: 3,
					borderBottom: `1px solid ${theme.palette.divider}`,
					bgcolor: theme.palette.background.paper,
					boxShadow: '0 2px 10px rgba(0, 0, 0, 0.03)'
				}}
			>
				<Typography
					variant="h5"
					component="h2"
					sx={{
						fontWeight: 700,
						letterSpacing: '0.05em',
						color: '#1E40AF',
						textAlign: 'center'
					}}
				>
					Daily Updates
				</Typography>

				<IconButton
					edge="end"
					color="inherit"
					onClick={onClose}
					aria-label="close"
					sx={{
						position: 'absolute',
						right: 16,
						color: 'text.secondary',
						'&:hover': {
							background: 'rgba(0, 0, 0, 0.04)'
						}
					}}
				>
					<CloseIcon />
				</IconButton>
			</DialogTitle>

			<DialogContent
				sx={{
					p: 0,
					display: 'flex',
					flexDirection: 'column',
					height: '100%',
					overflow: 'auto'
				}}
			>
				<RoleSelectionDailyUpdates />
			</DialogContent>
		</Dialog>
	);
};

export default DailyUpdatesAssistant;
